module.exports = __webpack_public_path__ + "img/4J.0d08102d.png";